import Icon from '../components/Icon.vue'

Icon.register({
  route: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M416 320c52.9 0 96 43.1 96 96s-43.1 96-96 96h-277.8c13.5-16.3 31.3-39.2 47.3-64h230.5c17.6 0 32-14.4 32-32s-14.4-32-32-32h-96c-52.9 0-96-43.1-96-96s43.1-96 96-96h45.3c-23.1-32.6-45.3-70.5-45.3-96 0-53 43-96 96-96s96 43 96 96-96 160-96 160h-96c-17.6 0-32 14.4-32 32s14.4 32 32 32h96zM416 64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM96 256c53 0 96 43 96 96s-96 160-96 160-96-107-96-160 43-96 96-96zM96 384c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/route.js
// module id = 1848
// module chunks = 0